import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import Grid from "@mui/material/Grid";
//Limitless imports
import { SignInForm, useExpertProfileContext } from "../../../../expert";
import PortalTextInput from "../../form-elements/portal-text-input/PortalTextInput";
import FormMessage from "../form-message/FormMessage";
import LoginButton from "../../buttons/login-button/LoginButton";
export const generalTextInputStyles = theme => ({
  textInputStyle: {
    WebkitBoxShadow: `0 0 0 1000px ${theme.palette.contrast.light} inset`,
    backgroundColor: theme.palette.contrast.light,
    borderRadius: 4
  },
  noBorderInput: {
    border: "none"
  }
});
const useStyles = makeStyles(theme => ({
  ...generalTextInputStyles(theme),
  fieldContainer: {
    width: "100%",
    maxWidth: 325,
    marginBottom: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around"
  },
  errorMessage: {
    minHeight: 20,
    marginBottom: 8,
    color: theme.palette.error.main,
    alignSelf: "center"
  },
  textInput: {
    display: "flex",
    flexDirection: "column"
  }
}));
export const passwordInputProps = (iconButtonClick, flag, classes) => ({
  endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
    position: "end"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: iconButtonClick,
    edge: "end",
    size: "large"
  }, !flag ? /*#__PURE__*/React.createElement(VisibilityOff, {
    color: "action"
  }) : /*#__PURE__*/React.createElement(Visibility, {
    color: "action"
  }))),
  classes: {
    root: classes.textInputStyle,
    notchedOutline: classes.noBorderInput
  }
});
const PortalSignInForm = ({
  isInitialRender,
  infoMessage,
  ...rest
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const classes = useStyles();
  const {
    loading: profileLoading
  } = useExpertProfileContext();
  const handleKeyPress = (event, isFormInvalid, onFormSubmit) => {
    if (event.key === "Enter" && !isFormInvalid) {
      onFormSubmit(null);
    }
  };
  return /*#__PURE__*/React.createElement(SignInForm, rest, ({
    email,
    password,
    fieldErrors,
    isFormInvalid,
    userErrorMessage,
    onEmailChange,
    onPasswordChange,
    onFormSubmit,
    loading
  }) => {
    return /*#__PURE__*/React.createElement("form", {
      className: classes.fieldContainer
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(FormMessage, {
      errorMessage: userErrorMessage,
      infoMessage: infoMessage
    })), /*#__PURE__*/React.createElement(PortalTextInput, {
      name: "email",
      label: "Email address",
      placeholder: "Your Email Address",
      id: "emailAddressInputField",
      onChange: event => onEmailChange(event.target.value),
      disabled: loading,
      value: email.value,
      error: fieldErrors.email ? true : false,
      helperText: fieldErrors.email,
      containerClass: classes.textInput,
      autoComplete: "email",
      color: "primary",
      onKeyPress: event => handleKeyPress(event, isFormInvalid, onFormSubmit),
      textInputClasses: {
        notchedOutline: classes.noBorderInput
      },
      inputProps: {
        className: classes.textInputStyle
      },
      largeHelperText: true,
      errorLabel: true
    }), /*#__PURE__*/React.createElement(PortalTextInput, {
      name: "password",
      label: "Password",
      placeholder: "Your Limitless Password",
      id: "passwordInputField",
      onChange: event => onPasswordChange(event.target.value),
      disabled: loading,
      value: password.value,
      error: fieldErrors.password ? true : false,
      helperText: fieldErrors.password,
      containerClass: classes.textInput,
      autoComplete: "current-password",
      color: "primary",
      onKeyPress: event => handleKeyPress(event, isFormInvalid, onFormSubmit),
      textInputClasses: {
        notchedOutline: classes.noBorderInput
      },
      type: showPassword ? "text" : "password",
      inputProps: {
        className: classes.textInputStyle
      },
      InputProps: passwordInputProps(() => setShowPassword(!showPassword), showPassword, classes),
      largeHelperText: true,
      errorLabel: true
    }), /*#__PURE__*/React.createElement(LoginButton, {
      disabled: loading || isFormInvalid,
      loading: loading || profileLoading,
      id: "signInButton",
      onClick: () => onFormSubmit()
    }, "Sign In"));
  });
};
export default PortalSignInForm;
PortalSignInForm.propTypes = {
  isInitialRender: PropTypes.bool.isRequired,
  infoMessage: PropTypes.string.isRequired
};